import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http/src/client';

import { Observable } from 'rxjs/Observable';

export class CustomTranslationLoader implements TranslateLoader {

    constructor(private http: HttpClient) {}

    getTranslation(lang: string): Observable<any> {
       return this.http.get(`./assets/i18n/${lang}.json`);
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/custom.translation.loader.ts